import { t, useLocale } from '../lib/i18n.js';
import type { PlayerPublic } from '@listen-draw/shared';

interface Props {
  players: PlayerPublic[];
  meId?: string | null;
  limit?: number;
  onKick?: (id: string) => void;
}

export function Ranking({ players, meId, limit, onKick }: Props) {
  useLocale();
  const list = limit ? players.slice(0, limit) : players;
  if (players.length === 0)
    return (
      <p className="muted small">
        {t('No players yet. Share the link to invite someone.', 'まだ参加者がいません。')}
      </p>
    );
  return (
    <div className="ranking">
      {list.map((p, i) => (
        <div
          key={p.id}
          className={`ranking__row${p.id === meId ? ' ranking__row--me' : ''}${p.connected ? '' : ' ranking__row--off'}`}
        >
          <span className="ranking__rank num">{i + 1}</span>
          <span className="ranking__name">
            {p.name}{' '}
            {p.status === 'answered' && (
              <span className="badge badge--live">{t('Answered', '回答済み')}</span>
            )}
            {p.status === 'correct' && (
              <span className="badge badge--ok">{t('Correct', '正解')}</span>
            )}
            {p.status === 'wrong' && <span className="badge badge--lock">×</span>}
            {!p.connected && <span className="badge">{t('Offline', '切断')}</span>}
          </span>
          <span className="ranking__score num">
            {p.score}
            {onKick && (
              <button
                className="btn btn--ghost"
                style={{ marginLeft: 6, padding: '2px 8px' }}
                onClick={() => onKick(p.id)}
                aria-label={t(`Remove ${p.name}`, `${p.name} を退出`)}
              >
                ×
              </button>
            )}
          </span>
        </div>
      ))}
      {limit && players.length > limit && (
        <p className="muted small">
          {t('More players: ', '他 ')}
          {players.length - limit} {t(' players', '人')}
        </p>
      )}
    </div>
  );
}
